'use client';
import {
  BREAKPOINTS,
  SPACING_1,
  SPACING_2,
  SPACING_4,
  WEB_PURPLE_REG,
  WEB_WHITE_REG,
} from '@mnd-frontend/ui/shared/tokens';
import { type ColorPropType, THEME, type ThemeUnion } from '@mnd-frontend/ui/shared/types/color';
import { memo } from 'react';
import styled from 'styled-components';
import Heading from '../../typography/Heading';

// #region styled components
const HeadingContainer = styled.header<{ $color: ColorPropType | undefined }>`
  text-align: center;
  margin-bottom: ${SPACING_4};
  margin-right: ${SPACING_2};
  margin-left: ${SPACING_2};
  color: ${({ $color }) => ($color ? $color : 'inherit')};

  @media (min-width: ${BREAKPOINTS.MD}px) {
    max-width: 50rem;
    margin-right: auto;
    margin-left: auto;
  }

  .headline {
    margin-bottom: ${SPACING_1};
  }
`;

const SubHeadline = styled.div`
    font-size: 1rem; // @todo: body/reg
    font-weight: 400;
    line-height: 1.5rem;
    margin-top: ${SPACING_1};
`;
// #endregion

type SectionHeaderProps = {
  headline: string | null;
  subHeadline?: string | null;
  isSmallFont?: boolean;
  colorScheme?: ThemeUnion;
};

const SectionHeader = ({
  headline,
  subHeadline,
  isSmallFont = false,
  colorScheme = THEME.INHERIT,
}: SectionHeaderProps) => {
  const getColor = () => {
    if (colorScheme !== THEME.INHERIT) {
      if (colorScheme === THEME.LIGHT) {
        return WEB_WHITE_REG;
      }

      return WEB_PURPLE_REG;
    }

    return undefined;
  };

  return (
    <HeadingContainer $color={getColor()}>
      <Heading className="headline" as="h2" color={getColor()} isSmallFont={isSmallFont}>
        {headline}
      </Heading>
      {subHeadline && <SubHeadline>{subHeadline}</SubHeadline>}
    </HeadingContainer>
  );
};
export default memo(SectionHeader);
